import React from 'react';
import axios from 'axios';
import { Button, Modal, FormGroup, ControlLabel, FormControl } from 'react-bootstrap';

import  DictListwy from '../DictListwy';

var AddZlecenie = React.createClass({

	getInitialState: function() {

		this.getDictListwy();
		return {
			addObject: {
				id: '',
				cena: 0.00,
				czyZdjecie: false,
				grubosc: '',
				hdf: false,
				kosztUslugi: '',
				lustro: false,
				numerListwy: '',
				numerPass: '',
				operator: '',
				punktSprzedazy: '',
				szerokosc: '',
				szklo: 'NIE',
				uwagi: '',
				wysokosc: '',
				zawieszka: false,
				dataZlozenia: '',
				imie: '',
				nazwisko: '',
				telefon: '',
				czyZrealizowane: '',
				zaliczka: '',
				pozostalaDoplata: '',
				dataOdbioru: '',
				czyPass: false,
			},
			dictListwa:{
				id: '',
	      numerListwy: '',
	      cenaZaMb: 0.00
			},
			dataDictListwy: null
		}
    },

	render: function() {

		return (
			<Modal show={this.props.parent.state.showAddModal}>
				<Modal.Header>
					<Modal.Title>Dodaj Zlecenie</Modal.Title>
				</Modal.Header>
				<Modal.Body>
						<div className="row">
							<div className="col-sm-4">
								<ControlLabel>Imię: </ControlLabel>
							</div>
							<div className="col-sm-8">
							<FormControl
								type="text"
								placeholder="Imię"
								value={this.state.addObject.imie}
								onChange={this.onAddZlecenieImieChange} />
							</div>
						</div>

						<div className="row">
							<div className="col-sm-4">
								<ControlLabel>Nazwisko: </ControlLabel>
							</div>
							<div className="col-sm-8">
							<FormControl
								type="text"
								placeholder="Nazwisko"
								value={this.state.addObject.nazwisko}
								onChange={this.onAddZlecenieNazwiskoChange} />
							</div>
						</div>

						<div className="row">
							<div className="col-sm-4">
								<ControlLabel>Telefon: </ControlLabel>
							</div>
							<div className="col-sm-8">
							<FormControl
								type="text"
								placeholder="Telefon"
								value={this.state.addObject.telefon}
								onChange={this.onAddZlecenieTelefonChange} />
							</div>
						</div>

						<div className="row">
							<div className="col-sm-4">
								<ControlLabel>Numer Listwy: </ControlLabel>
							</div>
							<div className="col-sm-8">
								<FormControl
									type="text"
									placeholder="Numer Listwy"
									value={this.state.addObject.numerListwy}
									onChange={this.onAddZlecenieNrListwyChange} />
									<ControlLabel>Cena za mb: {this.dictListwa ? (this.dictListwa.cenaZaMb ? this.dictListwa.cenaZaMb + ' zł' : '0.00 zł') : '0.00 zł'}</ControlLabel>
								</div>
						</div>

						<div className="row">
							<div className="col-sm-4">
								<ControlLabel>Szerokość: </ControlLabel>
							</div>
							<div className="col-sm-8">
							<FormControl
								type="text"
								placeholder="Szerokość"
								value={this.state.addObject.szerokosc}
								onChange={this.onAddZlecenieSzerokoscChange} />
							</div>
						</div>

						<div className="row">
							<div className="col-sm-4">
								<ControlLabel>Wysokość: </ControlLabel>
							</div>
							<div className="col-sm-8">
							<FormControl
								type="text"
								placeholder="Wysokość"
								value={this.state.addObject.wysokosc}
								onChange={this.onAddZlecenieWysokoscChange} />
							</div>
						</div>

						<div className="row">
							<div className="col-sm-4">
								<ControlLabel>Grubość: </ControlLabel>
							</div>
							<div className="col-sm-8">
							<FormControl
								type="text"
								placeholder="Grubość"
								value={this.state.addObject.grubosc}
								onChange={this.onAddZlecenieGruboscChange} />
							</div>
						</div>

						<div className="row">
							<div className="col-sm-4">
								<ControlLabel>Numer passparteau: </ControlLabel>
							</div>
							<div className="col-sm-8">
							<FormControl
								type="text"
								placeholder="Numer passparteau"
								value={this.state.addObject.numerPass}
								onChange={this.onAddZlecenieNrPassChange} />
							</div>
						</div>

						<div className="row">
							<div className="col-sm-4">
								<ControlLabel>Koszt usługi: </ControlLabel>
							</div>
							<div className="col-sm-8">
							<FormControl
								type="text"
								placeholder="Koszt usługi"
								value={this.state.addObject.kosztUslugi}
								onChange={this.onAddZlecenieKosztUslugiChange} />
							</div>
						</div>

						<div className="row">
							<div className="col-sm-4">
								<ControlLabel>Szkło: </ControlLabel>
							</div>
							<div className="col-sm-8">
								<select className="form-control" id="szklo"
											value={this.state.addObject.szklo}
											onChange={this.onAddZlecenieSzkloChange} >
									<option>Wybierz typ</option>
			            <option>Zwykłe</option>
			            <option>Antyrefleks</option>
			          </select>
							</div>
						</div>

						<div className="row">
							<div className="col-sm-4">
								<ControlLabel>HDF: </ControlLabel>
							</div>
							<div className="col-sm-8">
							<FormControl
								type="checkbox"
								checked={this.state.addObject.hdf}
								value={this.state.addObject.hdf}
								onChange={this.onAddZlecenieHdfChange} />
							</div>
						</div>

						<div className="row">
							<div className="col-sm-4">
								<ControlLabel>Zawieszka: </ControlLabel>
							</div>
							<div className="col-sm-8">
							<FormControl
								type="checkbox"
								checked={this.state.addObject.zawieszka}
								value={this.state.addObject.zawieszka}
								onChange={this.onAddZlecenieZawieszkaChange} />
							</div>
						</div>

						<div className="row">
							<div className="col-sm-4">
								<ControlLabel>Passparteau: </ControlLabel>
							</div>
							<div className="col-sm-8">
							<FormControl
								type="checkbox"
								checked={this.state.addObject.czyPass}
								value={this.state.addObject.czyPass}
								onChange={this.onAddZlecenieCzyPassChange} />
							</div>
						</div>

						<div className="row">
							<div className="col-sm-4">
								<ControlLabel>Lustro: </ControlLabel>
							</div>
							<div className="col-sm-8">
							<FormControl
								type="checkbox"
								checked={this.state.addObject.lustro}
								value={this.state.addObject.lustro}
								onChange={this.onAddZlecenieLustroChange} />
							</div>
						</div>

						<div className="row">
							<div className="col-sm-4">
								<ControlLabel>Czy zdjęcie: </ControlLabel>
							</div>
							<div className="col-sm-8">
							<FormControl
								type="checkbox"
								checked={this.state.addObject.czyZdjecie}
								value={this.state.addObject.czyZdjecie}
								onChange={this.onAddZlecenieZdjecieChange} />
							</div>
						</div>

						<div className="row">
							<div className="col-sm-4">
								<ControlLabel>Punkt sprzedaży: </ControlLabel>
							</div>
							<div className="col-sm-8">
								<select className="form-control" id="punktSprzedazy"
											value={this.state.addObject.punktSprzedazy}
											onChange={this.onAddZleceniepunktSprzedazyChange} >
									<option>Wybierz punkt</option>
			            <option>Castorama</option>
			            <option>Arena</option>
			          </select>
							</div>
						</div>

						<div className="row">
							<div className="col-sm-4">
								<ControlLabel>Sprzedawca: </ControlLabel>
							</div>
							<div className="col-sm-8">
								<select className="form-control" id="punktSprzedazy"
											value={this.state.addObject.operator}
											onChange={this.onAddZlecenieOperatorChange} >
									<option>Wybierz sprzedawcę</option>
									<option>Agnieszka Bułat</option>
									<option>Dominika Góźdź</option>
									<option>Jurek Czupik</option>
									<option>Aleksandra Koś</option>
									<option>Laura</option>
									<option>Ola Rybińska</option>
									<option>Sasza</option>
								</select>
							</div>
						</div>

						<div className="row">
							<div className="col-sm-4">
								<ControlLabel>Uwagi: </ControlLabel>
							</div>
							<div className="col-sm-8">
							<FormControl
								type="text"
								placeholder="Uwagi"
								rows="3"
								value={this.state.addObject.uwagi}
								onChange={this.onAddZlecenieUwagiChange} />
							</div>
						</div>

						<div className="row">
							<div className="col-sm-4">
								<ControlLabel>Zaliczka: </ControlLabel>
							</div>
							<div className="col-sm-8">
							<FormControl
								type="text"
								placeholder="Zaliczka"
								value={this.state.addObject.zaliczka}
								onChange={this.onAddZlecenieZaliczkaChange} />
							</div>
						</div>

				</Modal.Body>
				<Modal.Footer>
				<strong>Cena: {this.state.addObject.cena ? parseFloat(this.state.addObject.cena).toFixed(2) + ' zł' : '0.00 zł'}        </strong>
				<strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
				&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong>
					<Button onClick={this.props.parent.closeAddModal}>Zamknij</Button>
					<Button bsStyle="primary" onClick={this.onAddBtnClicked}>Dodaj</Button>
				</Modal.Footer>
			</Modal>
		);
	},

	clearAddObject: function() {
		this.state.addObject.id = '';
		this.state.addObject.imie = '';
		this.state.addObject.nazwisko = '';
		this.state.addObject.telefon = '';
		this.state.addObject.numerListwy = '';
		this.state.addObject.szerokosc = '';
		this.state.addObject.wysokosc = '';
		this.state.addObject.grubosc = '';
		this.state.addObject.cena = 0.00;
		this.state.addObject.numerPass = '';
		this.state.addObject.szklo = 'NIE';
		this.state.addObject.hdf = false;
		this.state.addObject.kosztUslugi = '';
		this.state.addObject.lustro = false;
		this.state.addObject.operator = '';
		this.state.addObject.uwagi = '';
		this.state.addObject.punktSprzedazy = '';
		this.state.addObject.czyZdjecie = false;
		this.state.addObject.zawieszka = false;
		this.state.addObject.dataZlozenia = '';
		this.state.addObject.czyZrealizowane = '';
		this.state.addObject.zaliczka = '';
		this.state.addObject.pozostalaDoplata = '',
		this.state.addObject.dataOdbioru = '',
		this.state.addObject.czyPass = false
	},

	onAddZlecenieImieChange: function(event) {
		this.state.addObject.imie = event.target.value;
		this.forceUpdate();
	},

	onAddZlecenieNazwiskoChange: function(event) {
		this.state.addObject.nazwisko = event.target.value;
		this.forceUpdate();
	},

	onAddZlecenieTelefonChange: function(event) {
		this.state.addObject.telefon = event.target.value;
		this.forceUpdate();
	},

	onAddZlecenieNrListwyChange: function(event) {
		this.state.addObject.numerListwy = event.target.value;

		this.dictListwa = this.getListwaByNrListwy(this.state.addObject.numerListwy);
		this.wyliczCene();
		this.forceUpdate();
	},

	onAddZlecenieNrPassChange: function(event) {
		this.state.addObject.numerPass = event.target.value;
		this.forceUpdate();
	},

	onAddZlecenieSzerokoscChange: function(event) {
		this.state.addObject.szerokosc = event.target.value.replace(/,/g, '.');
		this.wyliczCene();
		this.forceUpdate();
	},
	onAddZlecenieWysokoscChange: function(event) {
		this.state.addObject.wysokosc = event.target.value.replace(/,/g, '.');
		this.wyliczCene();
		this.forceUpdate();
	},

	onAddZlecenieGruboscChange: function(event) {
		this.state.addObject.grubosc = event.target.value.replace(/,/g, '.');
		this.wyliczCene();
		this.forceUpdate();
	},

	onAddZlecenieSzkloChange: function(event) {
		this.state.addObject.szklo = event.target.value;
		this.wyliczCene();
		this.forceUpdate();
	},

	onAddZlecenieHdfChange: function(event) {
		this.state.addObject.hdf = !this.state.addObject.hdf;
		this.wyliczCene();
		this.forceUpdate();
	},

	onAddZlecenieCzyPassChange: function(event) {
		this.state.addObject.czyPass = !this.state.addObject.czyPass;
		this.wyliczCene();
		this.forceUpdate();
	},

	onAddZlecenieKosztUslugiChange: function(event) {
		this.state.addObject.kosztUslugi = event.target.value.replace(/,/g, '.');
		this.wyliczCene();
		this.forceUpdate();
	},

	onAddZlecenieLustroChange: function(event) {
		this.state.addObject.lustro = !this.state.addObject.lustro;
		this.wyliczCene();
		this.forceUpdate();
	},

	onAddZlecenieOperatorChange: function(event) {
		this.state.addObject.operator = event.target.value;
		this.forceUpdate();
	},

	onAddZlecenieUwagiChange: function(event) {
		this.state.addObject.uwagi = event.target.value;
		this.forceUpdate();
	},

	onAddZleceniepunktSprzedazyChange: function(event) {
		this.state.addObject.punktSprzedazy = event.target.value;
		this.forceUpdate();
	},

	onAddZlecenieZdjecieChange: function(event) {
		this.state.addObject.czyZdjecie = !this.state.addObject.czyZdjecie;
		this.forceUpdate();
	},

	onAddZlecenieZawieszkaChange: function(event) {
		this.state.addObject.zawieszka = !this.state.addObject.zawieszka;
		this.wyliczCene();
		this.forceUpdate();
	},

	onAddZlecenieZaliczkaChange: function(event) {
		this.state.addObject.zaliczka = event.target.value.replace(/,/g, '.');
		this.wyliczCene();
		this.forceUpdate();
	},

	wyliczCene: function() {
	var dlListwy = (parseFloat(parseFloat(this.state.addObject.wysokosc * 2) + parseFloat(this.state.addObject.szerokosc * 2)) + parseFloat(this.state.addObject.grubosc * 8)) / 100
	var kosztListwy = this.dictListwa ? (dlListwy * (this.dictListwa ? parseFloat(this.dictListwa.cenaZaMb) : 1)) : 0.00

	if (!this.state.addObject.kosztUslugi) this.state.addObject.kosztUslugi = 0.00
	var kosztUslugi =  (this.state.addObject.kosztUslugi ? parseFloat(this.state.addObject.kosztUslugi) : 0.00)

	var pole = parseFloat((this.state.addObject.wysokosc / 100) * (this.state.addObject.szerokosc) / 100)
	var kosztSzkla = this.state.addObject.szklo ? parseFloat(60 * pole) : 0.00
	var kosztPass = this.state.addObject.czyPass ? parseFloat(70 * pole) : 0.00
	var kostLustra = this.state.addObject.lustro ? parseFloat(160 * pole) : 0.00
	var kosztHdf =  this.state.addObject.hdf ?  parseFloat(35 * pole) : 0.00
	var kosztZawieszki = this.state.addObject.zawieszka ? parseFloat(2.90) : 0.00

	kosztListwy = (isNaN(kosztListwy) ? 0.00 : kosztListwy);
	kosztUslugi = (isNaN(kosztUslugi) ? 0.00 : kosztUslugi);
	kosztSzkla = (isNaN(kosztSzkla) ? 0.00 : kosztSzkla);
  kosztPass = (isNaN(kosztPass) ? 0.00 : kosztPass);
	kostLustra = (isNaN(kostLustra) ? 0.00 : kostLustra);
	kosztHdf = (isNaN(kosztHdf) ? 0.00 : kosztHdf);
	kosztZawieszki = (isNaN(kosztZawieszki) ? 0.00 : kosztZawieszki);

	if(!this.state.addObject.zaliczka) this.state.addObject.zaliczka = 0.00
	if (this.state.addObject.szklo == 'false') this.state.addObject.szklo = 'NIE'
	if (this.state.addObject.szklo == 'Wybierz typ' || this.state.addObject.szklo == 'NIE') kosztSzkla = 0.00
	this.state.addObject.cena = parseFloat(kosztListwy + kosztUslugi + kosztSzkla + kosztPass + kostLustra + kosztHdf + kosztZawieszki)

		this.forceUpdate();
	},

	getDictListwy: function() {
		axios.get('http://217.182.200.222:8080/dictListwy')
		.then(function (dictListwa) {
			this.setState({dataDictListwy: dictListwa.data});
		}.bind(this));
	},

	getListwaByNrListwy: function(numerListwy) {
		for(var i in this.state.dataDictListwy) {
			if(this.state.dataDictListwy[i].numerListwy == numerListwy) {
				return this.state.dataDictListwy[i];
			}
		}
		return 'brak';
	},

	onAddBtnClicked: function() {
		axios.post('http://217.182.200.222:8080/zlecenie/', this.state.addObject)
			.then(function (response) {
				this.props.parent.closeAddModal();
				this.props.parent.refreshTable();
			}.bind(this))
			.catch(function (error) {
				alert("Błędnie wprowadzone dane");
				console.log(error);
			});
	}
});

export default AddZlecenie;



// WEBPACK FOOTER //
// ./src/components/Zlecenie/AddZlecenie.js